import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FJPhotoSettingBox.module.less';
import FJPhotoRemoveBgBgContainer from '../container/FJPhotoRemoveBgBgContainer';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJPhotoRemoveStrokeContainer from '../container/FJPhotoRemoveStrokeContainer';

const FJPhotoSettingBox = props => {
    const { isShow, disabled } = props;

    return (
        <div className={classNames(styles.setting_box, { [styles.show]: isShow, [styles.disabled]: disabled })}>
            <div className={styles.setting_title}>{FJLocalStore._('setting')}</div>
            <FJPhotoRemoveBgBgContainer />
            <FJPhotoRemoveStrokeContainer />
        </div>
    );
};

FJPhotoSettingBox.propTypes = {
    isShow: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default FJPhotoSettingBox;
